import type { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import type { MongoUserId } from "@redotech/effect-api-shared/ids/mongo-ids";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useAssigneeSelector } from "../hooks/use-assignee-selector";

export const AssigneeSelector = memo(function AssigneeSelector({
  conversationId,
  mongoAssigneeId,
}: {
  conversationId: ConversationId;
  mongoAssigneeId: MongoUserId | null;
}) {
  const {
    searchText,
    setSearchText,
    canEditAssignee,
    assigneeListItems,
    selectedItem,
    handleSelectAssignee,
  } = useAssigneeSelector({ conversationId, mongoAssigneeId });

  return (
    <Flex align="center" gap="md" justify="space-between">
      <Text fontSize="xs" textColor="secondary">
        Assignee
      </Text>
      <RedoSingleSelectDropdownInput
        fitToAnchor={false}
        options={assigneeListItems}
        optionSelected={({ item }) => handleSelectAssignee(item.value)}
        placeholder="Unassigned"
        readonly={!canEditAssignee}
        searchPlaceholder="Search for an option..."
        searchString={searchText}
        selectedItem={selectedItem}
        setSearchString={setSearchText}
        size="sm"
      />
    </Flex>
  );
});
